/**************
 Cart
 ***************/

// open cart
async function openCart(skipFetch = false) {
    // open cart if not already open
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }
    document.querySelector("body").classList.add("noScroll");

    // start loading animation
    document.querySelector("#miniCartContent").classList.add("loading");

    // hide empty cart section
    document.querySelector("#miniCartEmpty").classList.remove("active");

    // fetch cart
    if (skipFetch === false) {
        cart = await getCart();
    }

    // get cart item data
    const cartData = await fetch("/cart?view=supplemental-data")
        .then(response => response.json());
    const variantIDToSellingPlanName = cartData.variantIDToSellingPlanName;
    const variantIDToSellingPlanID = cartData.variantIDToSellingPlanID;
    const variantIDToCompareAtPrice = cartData.variantIDToCompareAtPrice;
    const variantCollectionIDs = cartData.variantCollectionIDs;

    // stop loading animation
    document.querySelector("#miniCartContent").classList.remove("loading");

    //  update cart count in header nav
    document.querySelector('#headerIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderCountNumber").textContent = `(${cart.item_count})`;

    // update cart count in checkout footer
    document.querySelector("#miniCartFooterSubtotalLabelCount").textContent = `(${cart.item_count} ${cart.item_count === 1 ? 'Item' : 'Items'})`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        document.querySelector("#miniCartEmpty").classList.add("active");
        document.querySelector("#miniCartBody").classList.remove("active");
        document.querySelector("#miniCartDiscountForm").classList.remove("active");
        document.querySelector("#miniCartUpsell")?.classList.remove("active");
        document.querySelector("#miniCartMysteryProduct")?.classList.remove("active");
        document.querySelector("#miniCartFooter").classList.remove("active");
        return;
    }

    // show main cart sections
    document.querySelector("#miniCartBody").classList.add("active");
    document.querySelector("#miniCartDiscountForm").classList.add("active");
    document.querySelector("#miniCartUpsell")?.classList.add("active");
    document.querySelector("#miniCartMysteryProduct")?.classList.add("active");
    document.querySelector("#miniCartFooter").classList.add("active");

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // Free shipping for subscription
    if (cartSettings.free_shipping_method === "subscription") {
        if (subscriptionItems > 0) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "Upgrade to a subscription for <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // Free shipping for price threshold
    if (cartSettings.free_shipping_method === "threshold") {
        let freeShippingThreshold = parseInt(cartSettings.free_shipping_threshold * 100);
        if (cart.total_price >= freeShippingThreshold) {
            document.querySelector("#miniCartHeaderShipping").innerHTML = "You've unlocked <b>FREE SHIPPING</b>";
            document.querySelector("#miniCartHeaderBarInner").classList.add("active");
        } else {
            document.querySelector("#miniCartHeaderShipping").innerHTML = `Spend<b> ${price(freeShippingThreshold - cart.total_price)}</b> more for <b>FREE SHIPPING</b>`;
            document.querySelector("#miniCartHeaderBarInner").style.width = `${(cart.total_price / freeShippingThreshold) * 100}%`;
            document.querySelector("#miniCartHeaderBarInner").classList.remove("active");
        }
    }

    // reset body container
    document.querySelectorAll(".miniCartBodyItem, .miniCartBodyKitItem").forEach(element => element.remove());

    // append cart
    cart.items
        .forEach(function (item) {
            // skip outfits and mystery boxes we add them later
            if (item?.properties?.kit_type || item?.properties?._mystery_box_id) {
                return;
            }

            const hasProperties = item.properties && Object.keys(item.properties).length > 0;

            // title HTML
            function titleHTML() {
                if (item.title.includes("-")) {
                    return item.title.split(" - ")[0].trim();
                }

                return item.title;
            }

            // size HTML
            function sizeHTML() {
                if (item.variant_title.includes(" / ")) {
                    return item.variant_title.split(" / ")[0].trim();
                }

                return false;
            }

            // color HTML
            function colorHTML() {
                if (item.title.includes(" - ")) {
                    return item.title.split(" - ")[1].trim();
                }

                return false;
            }

            // property HTML
            function propertiesHTML() {
                // check for any properties
                if (!hasProperties) {
                    return "";
                }

                // generate HTML for each item
                let HTML = `<div class="miniCartBodyItemProperties">`;
                for (const key in item.properties) {
                    // skip final sale
                    if (key === "_finalSale") {
                        return "";
                    }

                    // check for link
                    if (typeof item.properties[key] === "string" && item.properties[key].includes("https://")) {
                        HTML += `<a href="${item.properties[key]}" target="_blank">${key}</a><br>`;
                        continue;
                    }

                    // catch all
                    HTML += `<span class="miniCartBodyItemProperty ${key}">${item.properties[key]}</span><br>`;
                }
                HTML += `</div>`;

                // return string
                return HTML;
            }

            // price HTML
            function priceHTML() {
                let HTML = price(item.line_price, true);

                // there are 3 types of compare at prices (selling_plan_allocation, line item discount, compare at price)
                // calculate all 3 and the greatest one will be displayed if it is greater than the final line price
                const comparePrices = [];

                // check if selling_plan_allocation exists, if so append compare_at_price * quantity
                if (item.selling_plan_allocation) {
                    comparePrices.push(item.selling_plan_allocation.compare_at_price * item.quantity);
                }

                // check for line item discount
                if (item.line_price < item.original_line_price) {
                    comparePrices.push(item.original_line_price);
                }

                // check for compare at price
                if (variantIDToCompareAtPrice[item.variant_id]) {
                    comparePrices.push(variantIDToCompareAtPrice[item.variant_id] * item.quantity);
                }

                // if there is at least one compare price
                if (comparePrices.length > 0) {
                    // find the greatest compare price
                    const greatestComparePrice = Math.max(...comparePrices);

                    // check if the greatest compare price is greater than the final line price
                    if (greatestComparePrice > item.line_price) {
                        HTML += `
                        <s>${price(greatestComparePrice, true)}</s>
                    `;
                    }
                }

                // check for final sale property
                if (Object.keys(item.properties).includes("_finalSale")) {
                    HTML += `<span class="miniCartBodyItemPriceFinalSale">Final Sale</span>`
                }

                return HTML;
            }


            // upgrade button HTML
            function upgradeHTML() {

                // check if already a subscription
                if (item.selling_plan_allocation) {
                    return "";
                }

                // get selling plan id and name
                let sellingPlanID = variantIDToSellingPlanID[item.variant_id];
                let sellingPlanName = variantIDToSellingPlanName[item.variant_id];

                // check if selling plan exists
                if (!sellingPlanID) {
                    return "";
                }

                // return HTML
                return `
                <button 
                    class="miniCartBodyItemUpgrade button"
                     data-key="${item.key}"
                     data-quantity="${item.quantity}" 
                     data-plan="${sellingPlanID}"
                >
               ${sellingPlanName}
                </button>
            `;
            }

            // insert item
            document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", `
            <div class="miniCartBodyItem" data-key="${item.key}">
                <a class="miniCartBodyItemImageLink" href="/products/${item.handle}">
                    <img class="miniCartBodyItemImage" src="${item.image}&width=150" alt="${item.product_title}">
                </a>
                <div class="miniCartBodyItemWrapper">
                    <div class="miniCartBodyItemFlex">
                        <div>
                            <a class="miniCartBodyItemTitle" href="/products/${item.handle}">${titleHTML()}</a>
                            ${sizeHTML() ? `<div class="miniCartBodyItemSize">Size: ${sizeHTML()}</div>` : ''}
                            ${colorHTML() ? `<div class="miniCartBodyItemColor">${colorHTML()}</div>` : ''}
                            ${propertiesHTML()}
                        </div>
                        <div class="miniCartBodyItemPrice">${priceHTML()}</div>                              
                    </div>
                    <div class="miniCartBodyItemFlex miniCartBodyItemBottom center">
                        <div class="miniCartBodyItemQuantity">
                            <button class="miniCartBodyItemQuantityMinus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#757575" viewBox="0 0 11 2"><path stroke="#757575" stroke-linecap="round" stroke-linejoin="round" d="M1 1h9"></path></svg>
                            </button>
                            <div class="miniCartBodyItemQuantityCount">${item.quantity}</div>
                            <button class="miniCartBodyItemQuantityPlus">
                                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="none" viewBox="0 0 11 11"><path stroke="#757575" stroke-linecap="round" stroke-linejoin="round" d="M1 5.5h9M5.5 10V1"></path></svg>    
                            </button>
                        </div>
                        <button class="miniCartBodyItemRemove">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M11 8v7M7 8v7M1 4h16m-2 0v11.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 19 12.92 19 11.8 19H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 17.48 3 16.92 3 15.8V4zm-2 0H5c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.082-1.083C6.602 1 7.068 1 8 1h2c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C13 2.602 13 3.068 13 4"></path></svg>
                        </button>
                    </div>
                </div>
                ${upgradeHTML()}
                
                <div class="miniCartBodyItemActions">
                    <button class="miniCartBodyItemActionsWishlist">Move to <br> Wishlist</button>
                    <button class="miniCartBodyItemActionsRemove">Remove Item</button>
                </div>
            </div>
        `);

        });

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.dataset.key;

        // get current quantity
        let quantity = parseInt(element.querySelector(".miniCartBodyItemQuantityCount").textContent);

        // minus
        element.querySelector(".miniCartBodyItemQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // Show actions
        element.querySelector(".miniCartBodyItemRemove").addEventListener("click", function () {
            element.querySelector(".miniCartBodyItemActions").classList.add("active");
        });

        // Close actions
        element.querySelector(".miniCartBodyItemActions").addEventListener("click", function () {
            element.querySelector(".miniCartBodyItemActions").classList.remove("active");
        });

        // Remove
        element.querySelector(".miniCartBodyItemActionsRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // wishlist
        element.querySelector(".miniCartBodyItemActionsWishlist").addEventListener("click", async function () {
            const item = cart.items.find(item => item.key === element.dataset.key);

            await addProductToWishlist(item.product_id);

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [item.key]: 0
                }
            });

            // update active body
            await openCart();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemQuantityCount`).textContent = quantity;

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // update cart in shopify
            cart = await updateCart({
                updates: {
                    [key]: quantity
                }
            });

            // update active body
            await openCart();
        }

        // listen for upgrade button click
        element.querySelector(".miniCartBodyItemUpgrade")?.addEventListener("click", async function () {
            const key = this.dataset.key;
            const quantity = parseInt(this.dataset.quantity);
            const sellingPlanID = parseInt(this.dataset.plan);

            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            // add selling plan
            cart = await changeCart({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            await openCart(true);

            // remove loading animation
            this.classList.remove("loading");
        });
    });

    // Group kits by ID
    const kits = cart.items.filter(item => item?.properties?.kit_id).reduce((k, item) => {
        k[item.properties.kit_id] = k[item.properties.kit_id] || [];

        // Push matching kit to array
        k[item.properties?.kit_id].push(item);

        return k;
    }, {});

    // Get parent products for all kits
    const parentKitProducts = [];
    for (const kitKey of Object.keys(kits)) {
        const req = await fetch(`/products/${kits[kitKey][0].properties.kit_handle}.js`);
        const data = await req.json();
        parentKitProducts.push(data);
    }

    // Append kits
    Object.keys(kits).forEach((kit) => {
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", cartKitItemHTML(
                parentKitProducts[Object.keys(kits).indexOf(kit)],
                kits[kit]
            )
        );
    });

    // Group mystery boxes by ID
    const mysteryBoxes = cart.items.filter(item => item?.properties?._mystery_box_id).reduce((mb, item) => {
        mb[item.properties._mystery_box_id] = mb[item.properties["_mystery_box_id"]] || [];

        // Push matching kit to array
        mb[item.properties["_mystery_box_id"]].push(item);

        return mb;
    }, {});

    // Get parent products for all boxes
    const parentMysteryBoxProducts = [];
    for (const mysteryBox of Object.keys(mysteryBoxes)) {
        const req = await fetch(`/products/${mysteryBoxes[mysteryBox][0].properties["_mystery_box_handle"]}.js`);
        const data = await req.json();
        parentMysteryBoxProducts.push(data);
    }

    // Append boxes
    Object.keys(mysteryBoxes).forEach((mysteryBox) => {
        document.querySelector("#miniCartBody").insertAdjacentHTML("beforeend", cartKitItemHTML(
                parentMysteryBoxProducts[Object.keys(mysteryBoxes).indexOf(mysteryBox)],
                mysteryBoxes[mysteryBox]
            )
        );
    });

    function cartKitItemHTML(parentProduct, kit) {
        const id = kit[0].properties?.kit_id ? kit[0].properties?.kit_id.toString() : kit[0].properties["_mystery_box_id"];
        const discount = kit[0].properties?.kit_discount ? kit[0].properties.kit_discount : null;

        function outfitHTML(item, number) {
            const mysteryBoxId = item.properties["_mystery_box_id"] || "";
            return `
                <div class="miniCartBodyKitItemOutfitsItem" data-key="${item.key}" ${mysteryBoxId ? `data-mystery-box-id="${mysteryBoxId}"` : ""} >
                    <img class="miniCartBodyKitItemOutfitsItemImage" src="${item.image}" alt="${item.title}">
                    <div class="miniCartBodyKitItemOutfitsItemContent">
                        <div class="miniCartBodyKitItemOutfitsItemContentTitle">${number + 1}. ${
                            kit[0].properties?.kit_id ? item.title.split("-")[0] : `${item.product_title}`
                        }
                        </div>
                        <div class="miniCartBodyKitItemOutfitsItemContentBottom">
                            <div class="miniCartBodyKitItemOutfitsItemContentBottomSize"><strong>Size:</strong> ${item.options_with_values.find(option => option.name === "Size")?.value}</div>
                            <div class="miniCartBodyKitItemOutfitsItemContentBottomPrices">
                                <div class="miniCartBodyKitItemOutfitsItemContentBottomPricesCompare">${item.final_line_price < item.original_line_price ? price(item.original_line_price) : ""}</div>
                                <div class="miniCartBodyKitItemOutfitsItemContentBottomPricesReal">${price(item.final_line_price)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
        }

        const isFinalSale = kit.some(item => Object.keys(item.properties).includes("_finalSale"));

        return `
            <div class="miniCartBodyKitItem" data-id="${id}">
                <div class="miniCartBodyKitItemParentProduct">
                    <img class="miniCartBodyKitItemParentProductImage" src="${parentProduct.featured_image}" alt="${parentProduct.title}">
                    <div class="miniCartBodyKitItemParentProductContent">
                        <div class="miniCartBodyKitItemParentProductContentTitle">${parentProduct.title}</div>
                        <div class="miniCartBodyKitItemParentProductContentPrices">
                            <div class="miniCartBodyKitItemParentProductContentPricesReal">${price(parentProduct.price)}</div>
                            <div class="miniCartBodyKitItemParentProductContentPricesCompare">${price(parentProduct.compare_at_price)}</div>
                            ${isFinalSale ? ` <div class="miniCartBodyKitItemParentProductContentPricesFinalSale">Final Sale</div>` : ``}
                        </div>
                        <div class="miniCartBodyKitItemParentProductContentOutfitId">${kit[0].properties?.kit_id ? `Outfit ID:` : `Mystery Box ID:`}${id}</div>
                        ${discount ? `<div class="miniCartBodyKitItemParentProductContentSavings">You Save ${discount}%</div>` : ""}
                        <button class="miniCartBodyKitItemRemoveButton">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 20"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" d="M11 8v7M7 8v7M1 4h16m-2 0v11.8c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C13.48 19 12.92 19 11.8 19H6.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C3 17.48 3 16.92 3 15.8V4zm-2 0H5c0-.932 0-1.398.152-1.765a2 2 0 0 1 1.082-1.083C6.602 1 7.068 1 8 1h2c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C13 2.602 13 3.068 13 4"></path></svg>
                        </button>
                    </div>
                </div>
                <div class="miniCartBodyKitItemOutfits">
                    <div class="miniCartBodyKitItemOutfitsTitle">Items In Your ${kit[0].properties?.kit_id ? `Outfit` : `Mystery Box`}: ${kit.length}</div>
                    <div class="miniCartBodyKitItemOutfitsItems">
                        ${kit.map((item, idx) => outfitHTML(item, idx)).join(" ")}
                    </div>
                </div>
            </div>
        `
    }

    // Remove listener for kits
    document.querySelectorAll(".miniCartBodyKitItem").forEach((kitItem) => {
        kitItem.querySelector(".miniCartBodyKitItemRemoveButton").addEventListener("click", async function () {
            // start loading animation
            document.querySelector("#miniCartContent").classList.add("loading");

            for (const kit of kitItem.querySelectorAll(".miniCartBodyKitItemOutfitsItem")) {
                // update cart in shopify
                cart = await updateCart({
                    updates: {
                        [kit.dataset.key]: 0
                    }
                });
            }

            // update active body
            await openCart(true);
        });
    });

    // check if cart contains an upsell item
    document.querySelectorAll(".miniCartUpsellItem").forEach(element => {
        // get the product id
        let productID = parseInt(element.dataset.product);

        // check if product exists within the cart
        let isProductInCart = cart.items.find(item => item.product_id === productID);

        // hide if already in the cart
        if (isProductInCart) {
            // close main upsell
            document.querySelector("#miniCartUpsellContent").classList.remove("active");
        }
    });

    // check if all upsells are hidden
    if (document.querySelectorAll(".miniCartUpsellItem.active").length === 0) {
        document.querySelector("#miniCartUpsellContent")?.classList.remove("active");
    }

    // check if cart contains a mystery box upsell item
    const cartMysteryBoxUpsellItem = cart.items.find(item => {
        // see if item in cart belongs to selected mystery box collection
        return variantCollectionIDs[item.variant_id].includes(cartMysteryBoxCollectionID);
    });

    // Toggle disabled / active state based on there being a mystery product upsell in the cart
    document.querySelector("#miniCartMysteryProductContent")?.classList.toggle("active", !cartMysteryBoxUpsellItem);
    if (cartMysteryBoxUpsellItem) {
        // disable upsell atc
        document.querySelector(".miniCartMysteryProductItemWrapAdd")?.setAttribute("disabled", "");

        // disabled quantity selector on cart item
        document.querySelector(`.miniCartBodyItem[data-key="${cartMysteryBoxUpsellItem.key}"] .miniCartBodyItemQuantity`).classList.add("disabled");
    } else {
        // enable upsell atc
        document.querySelector(".miniCartMysteryProductItemWrapAdd")?.removeAttribute("disabled");
    }

    const cartDiscountCodes = getAllCartDiscounts(cart);
    const hasDiscounts = cartDiscountCodes.length > 0 || (Cookies.get("discount_code") !== undefined);
    const miniCartFooterDiscountsItemsEl = document.querySelector("#miniCartFooterDiscountsItems");

    // Reset Discounts
    miniCartFooterDiscountsItemsEl.innerHTML = "";

    // Toggle discount related elements
    document.querySelector("#miniCartFooterDiscounts").classList.toggle("active", hasDiscounts);
    document.querySelector("#miniCartDiscountForm").classList.toggle("active", getAllCartDiscounts(cart).filter(discount => discount.title !== "You Save").length < 1);

    function miniCartFooterDiscountsItemHTML(discount){
        return `
            <div id="${discount.title}" class="miniCartFooterDiscountsItem">
                <button class="miniCartFooterDiscountsItemButton">
                    ${discount.title}
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 45.255" class="discount-badge__close"><path d="m7.009 2.829 20.163 20.163L7.737 42.427l2.828 2.828L30 25.82l19.435 19.435 2.829-2.828-19.435-19.435L52.99 2.829 50.162 0 30 20.163 9.837 0z" data-original="M60 2.628v4H0v-4h60zM60 20.627v4H0v-4h60zM59.997 38.627v4H.02v-4h59.976z"></path><path d="M52.991 42.426 32.828 22.263 52.263 2.828 49.435 0 30 19.435 10.565 0 7.736 2.828l19.435 19.435L7.01 42.426l2.828 2.829L30 25.092l20.163 20.163z" class="u-hide"></path></svg>
                </button>
                <div class="miniCartFooterDiscountsItemAmount">-${price(discount.amount)}</div>
            </div>
        `
    }

    // Non Cookie Discount Codes
    cartDiscountCodes
        .filter(code => code.type !== "cookie")
        .forEach(discount => {
        // Append HTML
        const discountEl = document.createElement("div");
        discountEl.innerHTML = miniCartFooterDiscountsItemHTML(discount);
        miniCartFooterDiscountsItemsEl.appendChild(discountEl);

        // Remove Button
        document.querySelector(`.miniCartFooterDiscountsItem[id='${discount.title}']  .miniCartFooterDiscountsItemButton`)?.addEventListener("click", async function () {
            // Remove discount
            await handleDiscountRemove();
            // Reset discount form input
            document.querySelector("#miniCartDiscountForm input").value = "";
            // Open cart
            await openCart();
        });
    });

    // Cookie Discount Codes
    cartDiscountCodes
        .filter(code => code.type === "cookie")
        .forEach(discount => {
            // Append HTML
            miniCartFooterDiscountsItemsEl.innerHTML += miniCartFooterDiscountsItemHTML(discount);


            // Remove Button
            document.querySelector(`.miniCartFooterDiscountsItem[id='${discount.title}']  .miniCartFooterDiscountsItemButton`)?.addEventListener("click", async function () {
                // start loading animation
                document.querySelector("#miniCartContent").classList.add("loading");
                await fetch('/discount/REMOVE_ALL_DISCOUNT_CODES');
                Cookies.remove("discount_code");
                await openCart();
            });
        });

    // hide / show final sales message if the cart contains an item with the finalSale property
    document.querySelector("#miniCartFooterFinalSaleDisclaimer").classList.toggle("active", cart.items.find(item => Object.keys(item.properties).includes("_finalSale")) !== undefined);

    if (cart.original_total_price > cart.total_price) {
        document.querySelector("#miniCartFooterSubtotalAmountCompare").textContent = price(cart.original_total_price);
    } else {
        document.querySelector("#miniCartFooterSubtotalAmountCompare").textContent = "";
    }

    // update cart subtotal
    document.querySelector("#miniCartFooterSubtotalAmountReal").textContent = price(cart.total_price);
}

/**************
 Upsell
 ***************/

// Open upsell product selector
document.querySelector('.miniCartUpsellItemWrapATC')?.addEventListener("click", async function () {
    document.querySelector("#miniCartUpsellProductSelector").classList.toggle("active");
});

// Close Upsell product selector
document.querySelector("#miniCartUpsellProductSelectorHeaderClose")?.addEventListener("click", function () {
    document.querySelector("#miniCartUpsellProductSelector").classList.remove("active");
});

// Add upsell product item
document.querySelectorAll(".miniCartUpsellProductSelectorItemContentVariantsButton").forEach(item => {
    const variant = parseInt(item.dataset.id);
    item.addEventListener("click", async function () {
        // add product to cart
        await addProduct({
            items: [
                {
                    id: variant,
                    quantity: 1
                }
            ]
        });

        // send klaviyo event
        klaviyoAddToCart(item.dataset.handle);

        // close main upsell
        document.querySelector("#miniCartUpsellContent").classList.remove("active");

        // close upsell product selector
        document.querySelector("#miniCartUpsellProductSelector").classList.remove("active");

        await openCart();
    });
});

// Upsell Product Item Color Swatch
document.querySelectorAll(".miniCartUpsellProductSelectorItemContentColorsOption").forEach(button => {
    button.addEventListener("click", function () {
        // hide active product selector item
        document.querySelector(".miniCartUpsellProductSelectorItem.active").classList.remove("active");

        // find new
        document.querySelector(`.miniCartUpsellProductSelectorItem[data-product="${button.dataset.product}"]`).classList.add("active");
    });
});

document.addEventListener("DOMContentLoaded", async () => {
    const colorSwatches = await getGlobalColorSwatches();

    document.querySelectorAll(".miniCartUpsellProductSelectorItemContentColorsOption").forEach(button => {
        // Swatch logic
        const matchingSwatch = colorSwatches.find(color => color.handle === `swatch-${button.dataset.color}`);

        if (!matchingSwatch) {
            return;
        }

        const tag = matchingSwatch.fields.find(field => field.key === "tag");

        switch (tag.value) {
            case 'img':
                const image = matchingSwatch.fields.find(field => field.key === "image");
                button.style.backgroundImage = `url(${image.thumbnail.file.image.src})`;
                break;
            case 'hex':
                const gradientDirection = matchingSwatch.fields.find(field => field.key === "gradient_direction");
                if (gradientDirection.value) {
                    button.style.background = `linear-gradient(${gradientDirection.value})`;
                    break;
                }
                const color = matchingSwatch.fields.find(field => field.key === "color");
                button.style.backgroundColor = `${JSON.parse(color.value)[0]}`;
                break;
        }
    });
});

// Toggle mini cart upsell
document.querySelector("#miniCartUpsellTitleWrapper")?.addEventListener("click", function () {
    document.querySelector("#miniCartUpsellContent").classList.toggle("active");
});

/**************
 Mystery Product
 ***************/

// Toggle mini cart mystery product drawer
document.querySelector("#miniCartMysteryProductHeader")?.addEventListener("click", function () {
    document.querySelector("#miniCartMysteryProductContent").classList.toggle("active");
});

// Show mini cart mystery product size selector on add button click
document.querySelector(".miniCartMysteryProductItemWrapAdd")?.addEventListener("click", function () {
    document.querySelector("#miniCartMysteryProductSizeSelector").classList.add("active");
});

// Close mini cart mystery product size selector on header close button click
document.querySelector("#miniCartMysteryProductSelectorHeaderClose")?.addEventListener("click", closeMysteryProductSizeSelector);

// Size button click listeners
document.querySelectorAll(".miniCartMysteryProductSizeSelectorItem").forEach(item => {
    item.addEventListener("click", async function () {
        // grab the product ID
        const productID = parseInt(item.dataset.productId);

        // grab available variant ids for product
        const availableProductVariantIDs = cartMysteryBoxCollectionProducts.find(product => product.id === productID).variants.filter(variant => variant.available).flatMap(variant => variant.id);

        // Get random variant ID
        const randomAvailableVariantID = availableProductVariantIDs[Math.floor(Math.random() * availableProductVariantIDs.length)];

        // add the product to cart
        await addProduct({
            items: [
                {
                    id: randomAvailableVariantID,
                    quantity: 1,
                    properties: {
                        "_finalSale": "Final Sale"
                    }
                }
            ]
        });

        // close the selector
        closeMysteryProductSizeSelector();

        // open cart
        await openCart();
    });
});

/***
 * closeMysteryProductSizeSelector
 * @description Closes the Mystery Product Size Selector
 * @returns void
 **/
function closeMysteryProductSizeSelector() {
    document.querySelector("#miniCartMysteryProductSizeSelector").classList.remove("active");
}

// close event
document.querySelector("#miniCart").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// header close button
document.querySelector("#miniCartHeaderClose").addEventListener("click", closeCart);

// close cart function
function closeCart() {
    document.body.classList.remove("noScroll");
    document.querySelector("#miniCart").close();
}

// open cart event listener
document.querySelectorAll(".openCart").forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        openCart();
    });
});

// close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});

// close cart on overlay click
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
});

/**************
 Discounts
 ***************/

/***
 * Get all cart discounts
 * This function gets all discounts from the cart
 * including cart_level_discount_applications where the type is discount_code
 * and line item discounts where the line item has a discounts property
 * and cookie level discounts
 * @param cart {Object}
 * @returns Array
 **/
function getAllCartDiscounts(cart){
    const discounts = {};

    // There might be the same discount code applied on multiple line items. In that case we need to reduce it to one with the total applied value.
    for(const itemDiscount of cart.items.filter(item => item.hasOwnProperty("discounts")).flatMap(item => item.discounts)){
        const itemDiscountTitle = itemDiscount.title;
        let amount = itemDiscount.amount;

        // This discount is already on another line item, we'll add to it's amount instead of duplicating it
        if(discounts[itemDiscountTitle]?.amount){
            amount += discounts[itemDiscountTitle].amount;
        }

        discounts[itemDiscountTitle] = {
            title: itemDiscountTitle,
            amount: amount,
            type: "item"
        }
    }

    const cookieDiscount = Cookies.get("discount_code");
    if (cookieDiscount && !discounts.hasOwnProperty(cookieDiscount)) {
        discounts[cookieDiscount] = {
            title: cookieDiscount,
            amount: 0,
            type: "cookie"
        }
    }

    return [
        ...cart.cart_level_discount_applications.filter(discount => {
            // Must be a code and not exist in discounts object
            discount.type === "discount_code" && !discounts.hasOwnProperty(discount.title)
        }),
        ...Object.keys(discounts).flatMap(key => discounts[key])
    ];
}

// add discount
document.querySelector("#miniCartDiscountForm").addEventListener("submit", async function (e) {
    e.preventDefault();

    // loading
    e.submitter.classList.add("loading");

    await client.request(
        `
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
            cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
             userErrors {
              field
              message
            }
          }
        }
    `,
        {
            variables: {
                cartId: `gid://shopify/Cart/${cart.token}`,
                discountCodes: [this.querySelector("input").value]
            }
        }
    );

    // remove loading
    e.submitter.classList.remove("loading");

    // reopen cart
    await openCart();
});

// handle discount remove
async function handleDiscountRemove() {
    Cookies.remove("discount_code");

    return await client.request(
        `
        mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]) {
            cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
             userErrors {
              field
              message
            }
          }
        }
    `,
        {
            variables: {
                cartId: `gid://shopify/Cart/${cart.token}`,
                discountCodes: []
            }
        }
    );
}

// check if cart has mystery box items in DOM
function cartHasMysteryBoxItems() {
    const wrappers = document.querySelectorAll('#miniCartBody .miniCartBodyKitItemOutfitsItems');
  
    for (const wrapper of wrappers) {
      const mbItem = wrapper.querySelector('[data-mystery-box-id]');
      if (mbItem) return true;
    }
  
    return false;
}


// handle mb count attributes
async function updateMbCountAttributes() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
  
      const boxCounts = {};
      const updates = [];
  
      cart.items.forEach((item) => {
        const handle = item.properties?._mystery_box_handle;
        if (handle) {
          boxCounts[handle] = (boxCounts[handle] || 0) + 1;
  
          const newMbCount = boxCounts[handle];
          const currentMbCount = Number(item.properties._mb_count || 0);
  
          if (currentMbCount !== newMbCount) {
            updates.push({
              id: item.key,
              properties: {
                ...item.properties,
                _mb_count: newMbCount
              }
            });
          }
        }
      });
  
      // Sequential update requests
      for (const item of updates) {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.id,
            properties: item.properties
          })
        });
      }
  
    } catch (error) {
      console.error("Failed to update _mb_count attributes:", error);
    }
}
  
  

// checkout button loading
document.querySelector("#miniCartFooterCheckout").addEventListener("click", async function () {
    this.classList.add("loading");

    // formdata
    let formData = {
        items: []
    };

    // add to cart
    if (formData.items.length > 0) {
        await addProduct(formData);
    }

    // update _mb_count_new attributes before checkout 
    if (cartHasMysteryBoxItems()) {
        await updateMbCountAttributes();
    }

    // remove loading animation
    this.classList.remove("loading");

    // go to checkout
   window.location.href = `${Shopify.routes.root}checkout`;
});


// register dialog
dialogPolyfill.registerDialog(document.querySelector("#miniCart"));


// check is coming from the cart
if (document.referrer.includes("/cart")) {
    openCart();
}